module.exports = __webpack_public_path__ + "static/media/dry-clean.c90dbd4b.png";